import { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import SplashScreen from "./pages/SplashScreen";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Savings from "./pages/Savings";
import About from "./pages/About";
import Branches from "./pages/Branches";
import BranchBanking from "./pages/BranchBanking";
import BankHolidays from "./pages/BankHolidays";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import DosDonts from "./pages/DosDonts";
import Financials from "./pages/Financials";
import Loans from "./pages/Loans";
import LoanEnquiry from "./pages/LoanEnquiry";
import CustomerAwareness from "./pages/CustomerAwareness";
import CardsPage from "./pages/CardsPage";
import SmsBanking from "./pages/SmsBanking";
import AtmBanking from "./pages/AtmBanking";
import MobileBanking from "./pages/MobileBanking";
import UpiPage from "./pages/UpiPage";
import Shareholders from "./pages/Shareholders";
import BodPage from "./pages/BodPage";
import LoanEmiCalculator from "./pages/LoanEmiCalculator";
import DownloadCenter from "./pages/DownloadCenter";
import Services from "./pages/Services";
import LockerFacility from "./pages/LockerFacility";
import RtgsNeft from "./pages/RtgsNeft";
import Pmsby from "./pages/Pmsby";
import Pmjjby from "./pages/Pmjjby";
import Apamvm from "./pages/Apamvm";
import Kyc from "./pages/Kyc";
import Disclaimer from "./pages/DisclaimerPage";
import FeesChargesPage from "./pages/FeesChargesPage";
import DicgcPage from "./pages/DicgcPage";
import InterestRatesPage from "./pages/InterestRatesPage";
import GrievancePage from "./pages/GrievancePage";
import ATMComplaintPage from "./pages/ATMComplaintPage";
import JobPosting from "./pages/JobPosting";
import GalleryPage from './pages/GalleryPage';
import NewsPage from './pages/NewsPage';
import UnclaimedDeposits from './pages/Unclaimeddeposite';
import SchemesPage from './pages/SchemesPage';
import SecuredAssets from "./pages/Securedassets";
import ScrollToTop from "./pages/ScrollToTop";


function App() {

  // ─── SPLASH SCREEN ───────────────────────────────────────────
  // ✏️ To disable splash screen → change true to false below
const [showSplash, setShowSplash] = useState(
  !sessionStorage.getItem('splashShown')
);
  // ─────────────────────────────────────────────────────────────

  return (
    <>
      {showSplash && (
        <SplashScreen onFinish={() => {
          sessionStorage.setItem('splashShown', 'true');
          setShowSplash(false);
        }} />
      )}

      {/* MAIN WEBSITE */}
      <Router>
        <ScrollToTop />
        <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/savings" element={<Savings />} />
          <Route path="/loans" element={<Loans />} />
          <Route path="/about" element={<About />} />
          <Route path="/branches" element={<Branches />} />
          <Route path="/branch-banking" element={<BranchBanking />} />
          <Route path="/bank-holidays" element={<BankHolidays />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/dosdonts" element={<DosDonts />} />
          <Route path="/financials" element={<Financials />} />
          <Route path="/loan-enquiry" element={<LoanEnquiry />} />
          <Route path="/customer-awareness" element={<CustomerAwareness />} />
          <Route path="/cards-page" element={<CardsPage />} />
          <Route path="/sms-banking" element={<SmsBanking />} />
          <Route path="/atm-banking" element={<AtmBanking />} />
          <Route path="/mobile-banking" element={<MobileBanking />} />
          <Route path="/upi" element={<UpiPage />} />
          <Route path="/shareholders" element={<Shareholders />} />
          <Route path="/board-of-directors" element={<BodPage />} />
          <Route path="/loan-emi-calculator" element={<LoanEmiCalculator />} />
          <Route path="/download-center" element={<DownloadCenter />} />
          <Route path="/services" element={<Services />} />
          <Route path="/locker-facility" element={<LockerFacility />} />
          <Route path="/rtgs-neft" element={<RtgsNeft />} />
          <Route path="/pmsby" element={<Pmsby />} />
          <Route path="/pmjjby" element={<Pmjjby />} />
          <Route path="/apamvm" element={<Apamvm />} />
          <Route path="/kyc" element={<Kyc />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/fees-charges" element={<FeesChargesPage />} />
          <Route path="/dicgc" element={<DicgcPage />} />
          <Route path="/interest-rates" element={<InterestRatesPage />} />
          <Route path="/grievance" element={<GrievancePage />} />
          <Route path="/atm-complaint" element={<ATMComplaintPage />} />
          <Route path="/job-posting" element={<JobPosting />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/unclaimed-deposits" element={<UnclaimedDeposits />} />
          <Route path="/schemes" element={<SchemesPage />} />
          <Route path="/secured-assets" element={<SecuredAssets />} />
        </Routes>

        <Footer />
      </Router>
    </>
  );
}

export default App;